import React from 'react';
import PropTypes from 'prop-types';

export default function VirtualCardManagement(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 1140 815" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M122.143 0.571289C55.1679 0.571289 0 55.7391 0 122.714V692.714C0 759.689 55.1679 814.857 122.143 814.857H1017.86C1084.83 814.857 1140 759.689 1140 692.714V122.714C1140 55.7391 1084.83 0.571289 1017.86 0.571289H122.143ZM122.143 81.9999H1017.86C1040.86 81.9999 1058.57 99.7106 1058.57 122.714V204.143H122.143V285.571H1058.57V692.714C1058.57 715.718 1040.86 733.428 1017.86 733.428H122.143C99.1393 733.428 81.4286 715.718 81.4286 692.714V122.714C81.4286 99.7106 99.1393 81.9999 122.143 81.9999Z"
        fill={iconColor}
      />
    </svg>
  );
}

VirtualCardManagement.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

VirtualCardManagement.defaultProps = {
  width: 31.849,
  height: 24.137,
  iconColor: '#fff'
};
